import { all } from 'redux-saga/effects'

import sceneSaga from './sceneSaga'
import shopSaga from './shopSaga'
import activitySaga from './activitySaga'
import globalSaga from './globalSaga'
import orderSaga from './orderSaga'
import discountSaga from './discountSaga'

export default function* rootSagas() {
  yield all([
    ...sceneSaga,
    ...shopSaga,
    ...activitySaga,
    ...globalSaga,
    ...orderSaga,
    ...discountSaga,
  ])
}


// WEBPACK FOOTER //
// ./src/sagas/index.js